module.exports = __webpack_public_path__ + "040e67809c133aeb44326b32cac4ac4f.png";